export const allNewsUK = state => state.news.allNews.allNewsUK;
export const allNewsRU = state => state.news.allNews.allNewsRU;
export const allNewsErrorUK = state => state.news.allNews.allNewsErrorRU;
export const allNewsErrorRU = state => state.news.allNews.allNewsErrorRU;
export const allNewsLoading = state => state.news.allNews.loading;
export const allNewsPageNumberUK = state =>
  state.news.allNews.allNewsPageNumberUK;
export const allNewsPageNumberRU = state =>
  state.news.allNews.allNewsPageNumberRU;
